import React from 'react'

const Team = ({ name, position, image }) => {
    return (
        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item">
                <div className="d-flex justify-content-center overflow-hidden">
                    <img className="img-fluid fixed-size" src={image} alt={name} />
                </div>
                <div
                    className="position-relative d-flex justify-content-center"
                    style={{ marginTop: "-19px" }}
                >
                </div>
                <div className="text-center p-4">
                    <h5 className="mb-0">{name}</h5>
                    <small>{position}</small>
                </div>
            </div>
        </div>

    )
}

export default Team;
